// extracted by mini-css-extract-plugin
export default {"mobile-wrapper":"MobileWrapper_mobile-wrapper__39KhL","mobile-wrapper-list-view":"MobileWrapper_mobile-wrapper-list-view__1KjgJ"};